<template>
  <a-row class="ministry">
    <a-row class="content-title" type="flex">
      <h2 class="flex-1">
        {{ $route.meta.title[$i18n.locale] }}
      </h2>

      <a-row
        class="flex-no__wrap ml-auto wanted-search-input-wrapper"
        type="flex"
        style="justify-content: flex-end"
      />
    </a-row>

    <a-table
      :key="$route.fullPath"
      :columns="columns"
      :data-source="tableProps"
    >
      <template slot="name" slot-scope="item">
        <div
          style="cursor: pointer"
          @click="
            $router.push({
              name: item.name,
              params: {
                id: item.id
              }
            })
          "
        >
          {{ item.title[$i18n.locale] }}
        </div>
      </template>
    </a-table>
  </a-row>
</template>

<script>
// import searchInput from "@/components/wanted/search-input"

const columns = [
  {
    title: "Название",
    key: "title",
    class: "wanted-fio-td",
    scopedSlots: {
      customRender: "name"
    }
  }
]

export default {
  data: () => ({
    tableProps: [
      {
        title: {
          uz: "Ichki audit milliy malaka sertifikatlari reestri",
          oz: "Ички аудит миллий малака сертификатлари рэстри",
          ru: "Перечень национальных квалификационных сертификатов внутреннего аудита",
          en: "List of internal audit national qualification certificates"
        },
        id: 1,
        name: "statisticscrud"
      },
      {
        title: {
          uz: "Ichki audit xizmati rahbari va xodimlar faoliyati samaradorligining reytinggi",
          oz: "Ички аудит хизмати раҳбари ва ходимлар фаолияти самарадорлигининг рейтингги",
          ru: "Рейтинг эффективности деятельности руководителя и сотрудников службы внутреннего аудита",
          en: "Performance rating of the head and staff of the internal audit service"
        },
        id: 2,
        name: "kpicrud"
      },
      {
        title: {
          uz: "Fuqarolar ishtirokidagi audit tizimi orqali tanlangan nazorat obyektlari",
          oz: "Фуқаролар иштирокидаги аудит тизими орқали танланган назорат объектлари",
          ru: "Объекты контроля, выбранные через систему аудита с участием граждан",
          en: "Auditee selected through the audit system with the participation of citizens"
        },
        id: 3,
        name: "citizenaudit"
      },
      {
        title: {
          uz: "MTMS (SDDS)",
          oz: "МТМС (СДДС)",
          ru: "МТМС (СДДС)",
          en: "MTMS (SDDS)"
        },
        id: 4,
        name: "mtms"
      }
    ],
    columns
  }),
  methods: {}
}
</script>
<style>
.wanted-search-input-wrapper {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 430px;
  flex: 0 0 430px;
  justify-content: space-around;
}

/*.ministry .ant-table-pagination.ant-pagination {
  display: none;
}*/
</style>
